import { useState, useEffect, useRef, useCallback } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import InfiniteScroll from "react-infinite-scroll-component";
import { useUnmountEffect } from "primereact/hooks";

import { getAllProject } from "services";
import { CardProject } from "./card/CardProject";
import { SkeletonCards } from "./SkeletonCards";
import { EmptyCardList } from "./EmptyCardList";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  addProjects,
  nextPageProjects,
  resetProjectsState,
  resetState,
  setFirstLoadProjects,
  setHasNextPageProjects,
  setLoadingProjects,
  setProjects,
} from "store/slicer/GestioneProjectsSlice";
import { Project } from "interfaces";

export const ProjectCardsList = () => {
  const dispatch = useAppDispatch();
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);
  const filters = useAppSelector(
    (state) => state.gestioneProjectsSlice.filters
  );
  const projects = useAppSelector(
    (state) => state.gestioneProjectsSlice.projects
  );
  const hasNextPage = useAppSelector(
    (state) => state.gestioneProjectsSlice.hasNextPage
  );
  const loadingProjects = useAppSelector(
    (state) => state.gestioneProjectsSlice.loading
  );
  const firstLoad = useAppSelector(
    (state) => state.gestioneProjectsSlice.firstLoad
  );

  useUnmountEffect(() => {
    dispatch(resetProjectsState());
  });

  const fetchMoreData = useCallback(() => {
    if (!firstLoad && !loadingProjects && hasNextPage) {
      dispatch(nextPageProjects());
    }
  }, [dispatch, firstLoad, loadingProjects, hasNextPage]);

  const checkLayout = useCallback(() => {
    if (hasNextPage !== undefined) setHasMore(hasNextPage);
    setTimeout(() => {
      if (containerRef.current && hasNextPage) {
        if (
          containerRef.current?.scrollHeight <=
          containerRef.current?.clientHeight
        ) {
          if (!firstLoad && !loadingProjects && hasNextPage) {
            dispatch(nextPageProjects());
          }
        }
      }
    }, 200);
  }, [dispatch, hasNextPage, firstLoad, loadingProjects]);

  useEffect(() => {
    checkLayout();
  }, [checkLayout]);
  useUnmountEffect(() => {
    dispatch(resetProjectsState());
  });
  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);
  useEffect(() => {
    if (filters.pageIndex > 0) {
      dispatch(setLoadingProjects(true));
      if (filters.pageIndex === 1) {
        dispatch(setHasNextPageProjects(true));
      }
      getAllProject(filters)
        .then((response: any) => {
          const checkHasNextPage = response.data.totalPages > filters.pageIndex;
          if (filters.pageIndex === 1) {
            dispatch(setProjects(response.data));
            if (checkHasNextPage) {
              dispatch(nextPageProjects());
            } else {
              dispatch(setHasNextPageProjects(checkHasNextPage));
            }
          } else {
            dispatch(setHasNextPageProjects(checkHasNextPage));
            checkLayout();
            dispatch(addProjects(response.data.items ?? []));
          }
        })
        .catch((_) => {
          dispatch(setLoadingProjects(false));
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters]);

  useEffect(() => {
    if (!hasNextPage || filters.pageIndex > 1) {
      dispatch(setLoadingProjects(false));
      dispatch(setFirstLoadProjects(false));
      setHasMore(hasNextPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNextPage, filters.pageIndex]);

  return (
    <div id="scroll-div" ref={containerRef}>
      {loadingProjects ? (
        <SkeletonCards />
      ) : projects.items?.length ? (
        <>
          <InfiniteScroll
            style={{ overflow: "hidden" }}
            className="container-projects"
            dataLength={projects.items?.length ?? 0}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              hasMore && (
                <div className="spinner-wrapper">
                  <ProgressSpinner className="custom-spinner" />
                </div>
              )
            }
            scrollableTarget="scroll-div"
          >
            {projects?.items.map((project: Project, index: number) => (
              <CardProject project={project} key={index} />
            ))}
          </InfiniteScroll>
        </>
      ) : (
        <EmptyCardList filters={filters} />
      )}
    </div>
  );
};
